import React, { useCallback, useState, useContext } from "react";
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth'
import { MdMail, MdLock } from "react-icons/md";
import {
  // Link,
  Redirect,
  useHistory,
  useLocation
} from "react-router-dom";

import {AuthContext} from '../services/Session/Context'
import MiddleLayout from '../layouts/MiddleLayout'
import LoadableButton from '../components/LoadableButton'

const Login = () => {
  const { user, error: authError, loading: authLoading } = useContext(AuthContext)
  const history = useHistory();
  const location = useLocation();
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(authError && {
    type: 'danger',
    title: 'Erreur de connexion',
    message: 'Une erreur est survenue lors de votre connexion. Veuillez ressayer ultérieurement.'
  })

  // Manage authstate check locally
  const authLoadMsg = {
    type: 'info',
    title: 'Connexion en cours',
    message: 'Vous êtes peut être déjà connectés '
  }

  // Automatic redirect to original page after login
  const { from } = location.state || { from: { pathname: "/app" } };

  const handleSubmit = useCallback(async e => {
    e.preventDefault()
    setLoading(true)
    setError(undefined)
    const { email, password } = e.target.elements
    const auth = getAuth()
    try {
      await signInWithEmailAndPassword(auth, email.value, password.value)
      setLoading(false)
      history.replace(from);
    } catch (e) {
      setError({
        type: 'danger',
        title: 'Erreur de connexion',
        message: 'Votre e-mail et/ou votre mot de passe sont incorrects, veuillez réessayer'
      })
      setLoading(false)
    }
  }, [history, from])

  // Automatic redirect to original page if logged in
  if(user) {
    return <Redirect to={from} />
  }

  return (
    <MiddleLayout alerts={error || authError || (authLoading && authLoadMsg)}>
      <div className="flex flex-col w-full max-w-md px-4 py-8 bg-white rounded-lg shadow dark:bg-gray-800 sm:px-6 md:px-8 lg:px-10">
        <div className="self-center mb-6 text-xl font-light text-gray-600 sm:text-2xl dark:text-white">
          Connexion
        </div>
        <div className="mt-8">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col mb-2">
              <div className="flex relative ">
                <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b border-gray-300 text-gray-500 shadow-sm text-sm">
                  <MdMail size={15} />
                </span>
                <input type="text" name="email" className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" placeholder="Email"/>
              </div>
            </div>
            <div className="flex flex-col mb-6">
              <div className="flex relative ">
                <span className="rounded-l-md inline-flex  items-center px-3 border-t bg-white border-l border-b  border-gray-300 text-gray-500 shadow-sm text-sm">
                  <MdLock size={15}/>
                </span>
                <input type="password" name="password" className=" rounded-r-lg flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent" placeholder="Mot de passe"/>
              </div>
            </div>
            <div className="flex items-center mb-6 -mt-4">
              <div className="flex ml-auto">
                {/*<Link disabled to="/" className="inline-flex text-xs font-thin text-gray-500 sm:text-sm dark:text-gray-100 hover:text-gray-700 dark:hover:text-white">
                  Mot de passe oublié ?
                </Link>*/}
              </div>
            </div>
              <div className="flex w-full">
                <LoadableButton title="Se connecter" loading={loading || authLoading} isSubmit />
              </div>
          </form>
        </div>
        <div className="flex items-center justify-center mt-6">
          <a 
            href={`mailto:${process.env.REACT_APP_MAIL}?subject=[Autolini] Création de compte&body=Renseignez ici vos coordonnées afin que nous puissions vous contacter`}
            className="inline-flex items-center text-xs font-thin text-center text-gray-500 hover:text-gray-700 dark:text-gray-100 dark:hover:text-white">
            <span className="ml-2">
                Vous n'avez pas de compte ?
            </span>
          </a>
        </div>
      </div>
    </MiddleLayout>
  );
}

export default Login